import React, { useState } from 'react';
import { 
  Search, 
  Plus, 
  Edit, 
  Trash2, 
  Eye, 
  Building2,
  Phone,
  Mail,
  MapPin,
  Truck,
  Globe
} from 'lucide-react';

const Fournisseurs = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const fournisseurs = [
    {
      id: 1,
      nom: 'Maersk Line',
      contact: 'Thomas Andersen',
      email: 'contact@maersk.com',
      telephone: '+45 33 63 33 63',
      adresse: 'Esplanaden 50, 1263 Copenhagen K, Denmark',
      pays: 'Danemark',
      type: 'Transport maritime',
      statut: 'Actif',
      nombreLivraisons: 67
    },
    {
      id: 2,
      nom: 'MSC',
      contact: 'Gianluigi Aponte',
      email: 'info@msc.com',
      telephone: '+41 22 703 55 55',
      adresse: 'Rue de Lausanne 37-39, 1201 Geneva, Switzerland',
      pays: 'Suisse',
      type: 'Transport maritime',
      statut: 'Actif',
      nombreLivraisons: 58
    },
    {
      id: 3,
      nom: 'CMA CGM',
      contact: 'Rodolphe Saadé',
      email: 'contact@cmacgm.com',
      telephone: '+33 1 44 82 20 00',
      adresse: '4 Quai d\'Arenc, 13002 Marseille, France',
      pays: 'France',
      type: 'Transport maritime',
      statut: 'Actif',
      nombreLivraisons: 52
    },
    {
      id: 4,
      nom: 'Hapag-Lloyd',
      contact: 'Rolf Habben Jansen',
      email: 'info@hapag-lloyd.com',
      telephone: '+49 40 3001 0',
      adresse: 'Ballindamm 25, 20095 Hamburg, Germany',
      pays: 'Allemagne',
      type: 'Transport maritime',
      statut: 'Actif',
      nombreLivraisons: 41
    },
    {
      id: 5,
      nom: 'ONE',
      contact: 'Jeremy Nixon',
      email: 'contact@one-line.com',
      telephone: '+81 3 6225 1111',
      adresse: '2-2-2 Marunouchi, Chiyoda-ku, Tokyo 100-0005, Japan',
      pays: 'Japon',
      type: 'Transport maritime',
      statut: 'Actif',
      nombreLivraisons: 38
    },
    {
      id: 6,
      nom: 'Evergreen',
      contact: 'Chang Yung-fa',
      email: 'info@evergreen.com',
      telephone: '+886 2 2505 1188',
      adresse: '166-1, Section 2, Tiding Boulevard, Taipei 114, Taiwan',
      pays: 'Taiwan',
      type: 'Transport maritime',
      statut: 'Inactif',
      nombreLivraisons: 23
    }
  ];

  const filteredFournisseurs = fournisseurs.filter(fournisseur =>
    fournisseur.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
    fournisseur.contact.toLowerCase().includes(searchTerm.toLowerCase()) ||
    fournisseur.pays.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="space-y-6">
      {/* En-tête */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-port-gray-900">Gestion des fournisseurs</h1>
          <p className="text-port-gray-600">Gestion des fournisseurs ATL</p>
        </div>
        <button className="btn-primary flex items-center space-x-2">
          <Plus className="h-5 w-5" />
          <span>Nouveau fournisseur</span>
        </button>
      </div>

      {/* Statistiques */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="card p-6">
          <div className="flex items-center">
            <div className="p-3 rounded-lg bg-atl-blue-500">
              <Building2 className="h-6 w-6 text-white" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-port-gray-600">Total fournisseurs</p>
              <p className="text-2xl font-bold text-port-gray-900">{fournisseurs.length}</p>
            </div>
          </div>
        </div>
        
        <div className="card p-6">
          <div className="flex items-center">
            <div className="p-3 rounded-lg bg-atl-green-500">
              <Truck className="h-6 w-6 text-white" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-port-gray-600">Fournisseurs actifs</p>
              <p className="text-2xl font-bold text-port-gray-900">
                {fournisseurs.filter(f => f.statut === 'Actif').length}
              </p>
            </div>
          </div>
        </div>
        
        <div className="card p-6">
          <div className="flex items-center">
            <div className="p-3 rounded-lg bg-yellow-500">
              <Globe className="h-6 w-6 text-white" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-port-gray-600">Pays représentés</p>
              <p className="text-2xl font-bold text-port-gray-900">
                {new Set(fournisseurs.map(f => f.pays)).size}
              </p>
            </div>
          </div>
        </div>
        
        <div className="card p-6">
          <div className="flex items-center">
            <div className="p-3 rounded-lg bg-port-gray-500">
              <Truck className="h-6 w-6 text-white" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-port-gray-600">Livraisons totales</p>
              <p className="text-2xl font-bold text-port-gray-900">
                {fournisseurs.reduce((sum, fournisseur) => sum + fournisseur.nombreLivraisons, 0)}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Recherche */}
      <div className="card p-6">
        <div className="flex flex-col md:flex-row gap-4">
          <div className="flex-1">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-port-gray-400" />
              <input
                type="text"
                placeholder="Rechercher un fournisseur..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="input-field pl-10"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Tableau des fournisseurs */}
      <div className="card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-port-gray-200">
            <thead className="bg-port-gray-50">
              <tr>
                <th className="table-header px-6 py-3 text-left">Fournisseur</th>
                <th className="table-header px-6 py-3 text-left">Contact</th>
                <th className="table-header px-6 py-3 text-left">Coordonnées</th>
                <th className="table-header px-6 py-3 text-left">Pays</th>
                <th className="table-header px-6 py-3 text-left">Type</th>
                <th className="table-header px-6 py-3 text-left">Statut</th>
                <th className="table-header px-6 py-3 text-left">Livraisons</th>
                <th className="table-header px-6 py-3 text-left">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-port-gray-200">
              {filteredFournisseurs.map((fournisseur) => (
                <tr key={fournisseur.id} className="table-row">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <Building2 className="h-5 w-5 text-atl-blue-600 mr-2" />
                      <div>
                        <div className="font-medium text-port-gray-900">{fournisseur.nom}</div>
                        <div className="text-sm text-port-gray-500">{fournisseur.adresse}</div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-port-gray-900">{fournisseur.contact}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="space-y-1">
                      <div className="flex items-center text-sm text-port-gray-900">
                        <Mail className="h-4 w-4 mr-2 text-port-gray-400" />
                        {fournisseur.email}
                      </div>
                      <div className="flex items-center text-sm text-port-gray-900">
                        <Phone className="h-4 w-4 mr-2 text-port-gray-400" />
                        {fournisseur.telephone}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <Globe className="h-4 w-4 mr-2 text-port-gray-400" />
                      <span className="text-sm text-port-gray-900">{fournisseur.pays}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="text-sm text-port-gray-900">{fournisseur.type}</span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${
                      fournisseur.statut === 'Actif' ? 'bg-atl-green-100 text-atl-green-800' : 'bg-red-100 text-red-800'
                    }`}>
                      {fournisseur.statut}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="text-sm font-medium text-port-gray-900">{fournisseur.nombreLivraisons}</span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center space-x-2">
                      <button className="text-atl-blue-600 hover:text-atl-blue-700">
                        <Eye className="h-4 w-4" />
                      </button>
                      <button className="text-port-gray-600 hover:text-port-gray-700">
                        <Edit className="h-4 w-4" />
                      </button>
                      <button className="text-red-600 hover:text-red-700">
                        <Trash2 className="h-4 w-4" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Fournisseurs; 